import React, { useState } from 'react';
import styled from 'styled-components';

// 스타일 변수 (앱 전체 톤: 보라/화이트/그라데이션/카드/그림자)
const PURPLE = '#ffffff';
const LIGHT_PURPLE = '#e1bee7';
const DARK_PURPLE = '#4a148c';
const BG_GRADIENT = 'linear-gradient(135deg,rgba(0, 0, 0, 0.84) 0%,rgba(32, 32, 32, 0.89) 100%)';
const CARD_SHADOW = '0 6px 32px rgba(142,36,170,0.18)';
const FONT_FAMILY = 'Pretendard, Noto Sans KR, sans-serif';

// 경품 데이터
const prizeList = [
  { id: 1, image: '/images/nintendo.webp', name: '닌텐도 스위치2(5명)', description: '닌텐도 스위치2(5명)' },
  { id: 2, image: '/images/airpods-max.webp', name: '에어팟 맥스 2024(5명)', description: '에어팟 맥스 2024(5명)' },
  { id: 3, image: '/images/ipad-mini.webp', name: '아이패드 미니 A17 Pro(5명)', description: '아이패드 미니 A17 Pro(5명)' },
  { id: 4, image: '/images/airpods-pro2.webp', name: '에어팟 프로2(10명)', description: '에어팟 프로2(10명)' }
];

// 룰렛 경품 데이터
const roulettePrizes = [
  { id: 1, icon: '🎁', name: '배달의민족 1만원권(50명)', description: '배달의민족 1만원권(50명)' },
  { id: 2, icon: '🎁', name: '올리브영 5천원권(100명)', description: '올리브영 5천원권(100명)' },
  { id: 3, icon: '🎁', name: '네이버페이 3천원권(150명)', description: '네이버페이 3천원권(150명)' },
  { id: 4, icon: '🎁', name: '스니커즈 1개(300명)', description: '스니커즈 1개(300명)' },
  { id: 5, icon: '🎁', name: '바나나우유 1개(300명)', description: '바나나우유 1개(300명)' },
  { id: 6, icon: '🎁', name: '육개장 사발면 1개(350명)', description: '육개장 사발면 1개(350명)' },
  { id: 7, icon: '🎁', name: '마이쮸 1개(350명)', description: '마이쮸 1개(350명)' },
  { id: 8, icon: '🎁', name: '츄파춥스 1개(400명)', description: '츄파춥스 1개(400명)' }
];

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(30,0,50,0.45);
  z-index: 20000;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${FONT_FAMILY};
  
  @media (max-width: 768px) {
    width: 100vw;
    height: 100vh;
  }
`;

const ModalContent = styled.div`
  background: ${BG_GRADIENT};
  border-radius: 20px;
  max-width: 400px;
  width: 85vw;
  padding: 20px 16px 16px 16px;
  box-shadow: ${CARD_SHADOW};
  position: relative;
  color: #fff;
  font-family: ${FONT_FAMILY};
  border: 2px solid #fff;
  min-height: 200px;
  overflow: hidden;
  
  @media (max-width: 768px) {
    width: 90vw;
    padding: 8px 12px 8px 12px;
    min-height: 180px;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 18px;
  right: 18px;
  font-size: 22px;
  background: none;
  border: none;
  color: #fff;
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.2s;
  
  &:hover {
    opacity: 1;
  }
`;

const TopSpacer = styled.div`
  height: 16px;
  
  @media (max-width: 768px) {
    height: 12px;
  }
`;

const ContentContainer = styled.div`
  text-align: center;
  margin-bottom: 16px;
  
  @media (max-width: 768px) {
    margin-bottom: 12px;
  }
`;

const Title = styled.h2`
  margin-top: 0;
  margin-bottom: 12px;
  font-weight: 800;
  letter-spacing: -1px;
  font-size: 24px;
  color: #fff;
  text-shadow: 0 2px 8px #6a1b9a55;
  
  @media (max-width: 768px) {
    font-size: 20px;
    margin-bottom: 8px;
  }
`;

const Description = styled.p`
  margin: 0 0 12px 0;
  font-size: 14px;
  line-height: 1.5;
  color: #fff;
  
  @media (max-width: 768px) {
    font-size: 12px;
    margin: 0 0 8px 0;
  }
`;

const PrizeBox = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  margin: 12px 0;
  
  @media (max-width: 768px) {
    grid-template-columns: repeat(4, 1fr);
    gap: 4px;
    margin: 8px 0;
  }
`;

const PrizeItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 10px 6px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  transition: all 0.2s ease;
  
  &:hover {
    background: rgba(255, 255, 255, 0.12);
    border-color: rgba(255, 255, 255, 0.25);
    transform: translateY(-2px);
  }
  
  @media (max-width: 768px) {
    padding: 6px 3px;
    border-radius: 8px;
  }
`;

const PrizeCircle = styled.div`
  width: 50px;
  height: 50px;
  background-color: rgba(255, 255, 255, 0.14);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 6px;
  box-shadow: 0 4px 12px rgba(142, 36, 170, 0.3);
  border: 2px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
  
  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
    margin-bottom: 4px;
    border: 1px solid rgba(255, 255, 255, 0.2);
  }
`;

const PrizeImage = styled.img`
  width: 40px;
  height: 40px;
  object-fit: contain;
  border-radius: 50%;
  
  @media (max-width: 768px) {
    width: 28px;
    height: 28px;
  }
`;

const PrizeLabel = styled.div`
  font-size: 0.7rem;
  font-weight: 600;
  color: #fff;
  margin-bottom: 2px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
  word-break: keep-all;
  
  @media (max-width: 768px) {
    word-break: keep-all;
    font-size: 0.6rem;
    margin-bottom: 1px;
  }
`;

const PrizeDescription = styled.div`
  font-size: 9px;
  color: ${LIGHT_PURPLE};
  line-height: 1.2;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
  text-align: center;
  word-break: keep-all;
  max-width: 60px;
  
  @media (max-width: 768px) {
    font-size: 8px;
    max-width: 50px;
  }
`;

const Notice = styled.p`
  font-size: 0.6rem;
  color: ${LIGHT_PURPLE};
  margin: 0;
  line-height: 1.4;
  text-align: left;
  word-break: keep-all;
  
  @media (max-width: 768px) {
    font-size: 0.5rem;
    line-height: 1.3;
  }
`;

const ConfirmButton = styled.button`
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 12px;
  font-weight: 700;
  font-size: 15px;
  padding: 8px 0;
  width: 100%;
  margin: 8px 0 0 0;
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    background: rgba(255, 255, 255, 0.2);
    border-color: rgba(255, 255, 255, 0.5);
  }
`;

const Checkbox = styled.input`
  accent-color: ${PURPLE};
  width: 18px;
  height: 18px;
  cursor: pointer;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 3px;
  background: rgba(255, 255, 255, 0.1);
  position: relative;
  
  &:checked {
    border-color: ${PURPLE};
  }
  
  &:checked::after {
    content: '✓';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: ${PURPLE};
    font-size: 14px;
    font-weight: bold;
    line-height: 1;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
  }
  
  @media (max-width: 768px) {
    width: 20px;
    height: 20px;
    min-width: 20px;
    min-height: 20px;
    
    &:checked::after {
      font-size: 16px;
    }
  }
`;

const CheckboxLabel = styled.label`
  margin-left: 8px;
  font-weight: 500;
  font-size: 13px;
  cursor: pointer;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  
  @media (max-width: 768px) {
    font-size: 12px;
    margin-left: 10px;
    padding: 4px 0;
  }
`;

const DontShowContainer = styled.div`
  margin-top: 12px;
  display: flex;
  align-items: center;
  color: #fff;
  padding: 4px 0;
  
  @media (max-width: 768px) {
    margin-top: 8px;
    padding: 6px 0;
  }
`;

const PrizeSection = styled.div`
  margin-bottom: 16px;
  
  @media (max-width: 768px) {
    margin-bottom: 12px;
  }
`;

const SectionTitle = styled.h3`
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  margin: 0 0 8px 0;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
  
  @media (max-width: 768px) {
    font-size: 14px;
    margin: 0 0 6px 0;
  }
`;

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  margin: 16px 0;
  
  @media (max-width: 768px) {
    margin: 12px 0;
  }
`;

const RouletteBox = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 6px;
  margin: 8px 0;
  
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 3px;
    margin: 6px 0;
  }
`;

const RouletteItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: #fff;
  padding: 5px 6px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  
  @media (max-width: 768px) {
    padding: 3px 4px;
    gap: 3px;
    border-radius: 6px;
  }
`;

const RouletteIcon = styled.span`
  font-size: 12px;
  color: ${LIGHT_PURPLE};
`;

const RouletteText = styled.span`
  font-size: 0.75rem;
  color: #fff;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
  line-height: 1.2;
  
  @media (max-width: 768px) {
    font-size: 0.65rem;
    line-height: 1.2;
  }
`;

const InfoPopup = ({ onClose }) => {
  const [dontShowToday, setDontShowToday] = useState(false);

  // 오늘 하루 보지 않기 체크박스 핸들러
  const handleDontShowToday = (e) => {
    setDontShowToday(e.target.checked);
  };

  // 닫기 버튼 클릭 시 오늘 하루 보지 않기 처리
  const handleClose = () => {
    if (dontShowToday) {
      const today = new Date();
      const yyyy = today.getFullYear();
      const mm = String(today.getMonth() + 1).padStart(2, '0');
      const dd = String(today.getDate()).padStart(2, '0');
      const dateStr = `${yyyy}-${mm}-${dd}`;
      localStorage.setItem('prize_info_hide_date', dateStr);
    }
    if (onClose) onClose();
  };

  return (
    <ModalOverlay>
      <ModalContent>
        <CloseButton onClick={handleClose} title="닫기">✕</CloseButton>
        <TopSpacer />
        <ContentContainer>
          <Title>경품 정보</Title>
          
          {/* <Description>
            이벤트에 참여하시면 다양한 경품을 받으실 수 있습니다!
          </Description> */}
          <Divider />

          <PrizeSection>
            <SectionTitle>🏆 메인 경품</SectionTitle>
            <PrizeBox>
              {prizeList.map((prize) => (
                <PrizeItemContainer key={prize.id}>
                  <PrizeCircle>
                    <PrizeImage src={prize.image} alt={prize.description} />
                  </PrizeCircle>
                  <PrizeLabel>{prize.name}</PrizeLabel>
                  {/* <PrizeDescription>{prize.description}</PrizeDescription> */}
                </PrizeItemContainer>
              ))}
            </PrizeBox>
          </PrizeSection>
          
          <Divider />
          
          <PrizeSection>
            <SectionTitle>🎰 룰렛 경품</SectionTitle>
            <RouletteBox>
              {roulettePrizes.map((prize) => (
                <RouletteItem key={prize.id}>
                  {/* <RouletteIcon>{prize.icon}</RouletteIcon> */}
                  <RouletteText>{prize.name}</RouletteText>
                </RouletteItem>
              ))}
            </RouletteBox>
          </PrizeSection>
          
          <Notice>
            * 이미지는 참고용으로 실제 경품과 다를 수 있습니다.<br/>
            * 경품 응모 추첨의 경우 9월 8일(월)부터 개별 안내되며, 모든 리워드(경품 및 룰렛 기프티콘 포함)는 9월 15일(월)부터 순차 발송됩니다.<br/>
            * 5만 원 초과에 따른 제세공과금은 주최측에서 부담하며, 경품 수령을 위한 추가 개인정보 기입이 요구될 수 있습니다.
          </Notice>
        </ContentContainer>
        
        <ConfirmButton onClick={handleClose}>
          확인
        </ConfirmButton>
        
        <DontShowContainer>
          <Checkbox 
            type="checkbox" 
            id="dontShowToday" 
            checked={dontShowToday} 
            onChange={handleDontShowToday} 
          />
          <CheckboxLabel htmlFor="dontShowToday">
            오늘 하루 보지 않기
          </CheckboxLabel>
        </DontShowContainer>
      </ModalContent>
    </ModalOverlay>
  );
};

export default InfoPopup; 